import { Component, input } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  styleUrl: './tooltip.component.scss',
  template: `
    <div
      [pTooltip]="content()"
      [tooltipPosition]="position()"
      [showDelay]="showDelay()"
      [hideDelay]="hideDelay()"
      [tooltipStyleClass]="customClass()"
      [tooltipDisabled]="disabled()"
      [escape]="false"
      [autoHide]="autoHide()"
      [tooltipZIndex]="zIndex()"
      [tooltipEvent]="event()"
      [class]="wrapperClass()"
    >
      <ng-content></ng-content>
    </div>
  `,
})
export class TooltipComponent {
  content = input.required<string>();

  position = input<'top' | 'bottom' | 'left' | 'right'>('right');
  showDelay = input<number>(0);
  hideDelay = input<number>(0);
  customClass = input<string>('p-tooltip-no-arrow');
  disabled = input<boolean>(false);
  autoHide = input<boolean>(true);
  zIndex = input<string>('auto');
  event = input<'hover' | 'focus'>('hover');
  wrapperClass = input<string>('tooltip-wrapper');
}
